import styled from 'styled-components';

export const ItemActions = styled.div`
  padding-top: 16px;
`;
